import { session } from 'store2'
import Keys from '../Keys'
import axios from 'axios'
import Config from '../Config'

const URLUsuario = '/Sistema/Usuario?idOperacao=';

const headers = {
    'Authentication': `Basic ${Config.API_KEY}`
}

class Usuarios {


    currentUser = null;

    isAuthenticated() {

        if(window.location.href.indexOf('localhost') >= 0){
            let data = localStorage.getItem(Keys.CURR_USER_KEY);
            let json = JSON.parse(data);

            return json && json != null && json != {}; 
        }

        return session.has(Keys.CURR_USER_KEY)
    }

    getCurrentUser() {

        if(window.location.href.indexOf('localhost') >= 0){
            let data = localStorage.getItem(Keys.CURR_USER_KEY);
            return JSON.parse(data);
        }

        return session.get(Keys.CURR_USER_KEY)
    }
    setCurrentUser(data){

        const idUsuarioSistema = -1; //Se o usuário for externo aqui passaremos o idUsuarioSistema
        const credenciais = {
            token: data.congressistaToken,
            idUsuario: data.idUsuario == 0 ? idUsuarioSistema : data.idUsuario,
            iddkk: data.iddkk,
            optLogin: data.optLogin
        };

        if(window.location.href.indexOf('localhost') >= 0){

            localStorage.setItem(Keys.CURR_USER_KEY, JSON.stringify(credenciais));

            return;
        }

        if(data && data.congressistaToken){       
            
            session.add(Keys.CURR_USER_KEY, credenciais);
        }
    }

    setCurrentUserLocalState(data){

        localStorage.setItem(Keys.CURR_USER_KEY, JSON.stringify(data));

    }

    validate(username, password) {

        let url = `${Config.API_URL}${URLUsuario}14`

        return axios.post(url, { idOperacao: 14, coAcesso: username, coSenha: password,icEventos:true }, { headers: headers })
            .then(response => {
                let resposta = { sucesso: false, Mensagem: 'Ocorreu um erro ao submeter as informações' }

                if (response.data.data.Regra === null) {
                    resposta.sucesso = true
                    resposta.Mensagem = ''
                    resposta.data = response.data.data

                    session.add(Keys.CURR_USER_KEY, {
                        idUsuario: response.idUsuario,
                        name: response.nmUsuario,
                        email: response.edEmail,
                        token: 'XXXXXXXXXXXXXX-YYYYYYYYYYYYYYYYYY-OOOOOOOOOOOOOO'
                    })
                }
                else {
                    resposta.Mensagem = response.data.data.Regra.deRegra
                }
                return resposta
            })
            .catch(function (error) {
                return { sucesso: false, Mensagem: 'Ocorreu um erro ao submeter as informações', data: null }
            })
    }

    logout() {

        localStorage.removeItem(Keys.CURR_USER_KEY);
        session.remove(Keys.CURR_USER_KEY)
    }
}

const AppUsers = new Usuarios()

export default AppUsers


// WEBPACK FOOTER //
// ./src/services/Usuarios.js